import {Component, ElementRef, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {DisposeMixin} from "../../../shared/mixins/dispose.mixin";
import {EmptyMixin} from "../../../shared/mixins/empty.mixin";
import {ConfigurationService} from "../../../shared/services/configuration.service";
import {CofaWidgetConfigModel} from "../../models/cofa-widget/cofa-widget-config.model";
import {CofaWidgetService} from "../../services/cofa-widget.service";

@Component({
    selector: "pcg-ng-cofa-widget",
    template: require('./cofa-widget.component.html')
})
export class CofaWidgetComponent extends DisposeMixin(EmptyMixin) implements OnInit, OnDestroy {
    private searchModeSubscription: Subscription;
    private lotNumberSubscription: Subscription;

    public isSearchMode: boolean;

    public lotNumber: string;

    public constructor(
        private domElement: ElementRef,
        private configService: ConfigurationService<CofaWidgetConfigModel>,
        private cofaWidgetService: CofaWidgetService
    ) {
        super();
        this.configService.initialize(this.domElement.nativeElement.dataset);
    }

    public ngOnInit(): void {
        this.searchModeSubscription = this.cofaWidgetService.searchModeObserver
            .subscribe(isSearchMode => this.isSearchMode = isSearchMode);

        this.lotNumberSubscription = this.cofaWidgetService.lotNumberObserver
            .subscribe(lotNumber => this.lotNumber = lotNumber);
    }

    public ngOnDestroy(): void {
        this.dispose();
    }
}
